export default "__VITE_ASSET__BrSlUQRT__"